export default __webpack_public_path__ + "static/media/640_private03-it-web.1a2c3640.png";